import Vue from 'vue';
import Router from 'vue-router';
import displayRoutes from './route/display';
import scout_routes from './route/scout';
import fiveRouters from './route/five';
import expire_student_routes from './route/expire_student'; // 到期学员
import setting_routes from './route/setting';
import notice_routes from './route/notice';
import system_manager_routes from './route/system_manager';
import train_manaer_routes from './route/training_manager';
import traing_teacher_routes from './route/training_teacher';
import base_routes from './route/base';
import training_student from '@/route/training_student';
import registration from '@/route/registration'
import survey from '@/route/survey';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    /* ================= 基础路由信息 （包含未登录部分页面）=================== */
    ...base_routes,

    // 设置页面
    setting_routes,
    // 通知

    notice_routes,
    /* =================system_manager================== */
    system_manager_routes,
    
    /* ====================training_manager=================== */
    train_manaer_routes,

    /* ====================training_teacher=================== */
    traing_teacher_routes,

    /* =================training_student================ */
    training_student,

    /* =================registration================ */
    registration,

    /* =================expire_student================ */
    expire_student_routes,

    /* 问卷调查（已修改main.js权限，所有角色都可以访问） */
    survey,

    /* ================= scout 球探模块 ================ */
    scout_routes,
    
    /* ================= 大数据模块 ================ */
    ...displayRoutes,
    
    /* ================= 五人制 ================ */
    ...fiveRouters,
  ]
})
